@if (session) {
  @if (ngxSessionService.mayEdit(session)) {
    <button mat-menu-item class="menu-edit" (click)="onEdit()">{{"common_edit" | translate}}</button>
  }
  @if (ngxSessionService.hasVideoSharePermission(session) && isPosted()) {
    <button mat-menu-item class="menu-share" (click)="shareSession()">{{ 'modal-video-share-dialog_title' | translate }}</button>
  }
  @if (ngxSessionService.hasVideoSharePermission(session)) {
    <button mat-menu-item class="menu-manage" (click)="onEdit(1)">{{ 'session-list-item_manage-reviewers' | translate}}</button>
  }
  @if (ngxSessionService.mayDelete(session)) {
    <button mat-menu-item class="menu-archive" data-cy="delete-session" (click)="confirmArchiveSession()">{{"common_archive" | translate}}</button>
  }
  @if (session.viewed) {
    <button mat-menu-item class="menu-mark-unviewed" (click)="markUnviewed()">{{"session-list-item_mark-unviewed" | translate}}</button>
  }
  @if (!session.viewed) {
    <button mat-menu-item class="menu-mark-viewed" (click)="markViewed()">{{"session-list-item_mark-viewed" | translate}}</button>
  }
  @if (shouldShowRetakeLink()) {
    <button mat-menu-item class="menu-allow-retake" (click)="archiveSession()">{{'session-list-item_allow-retake' | translate}}</button>
  }
}
